import styled from '@emotion/styled'

export const BreadcrumbsWrapper = styled.div`
  display: flex;
  align-items: center;
`
